import request from "root/js/request";

const getCommissionsAndDiscountsByCategories = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  category_id__in,
  brand_id__in,
  supplier_article__in,
  product_id__in,
  barcode__in,
  subject_id__in,
}) => {
  const response = await request({
    url: "/analytics/commission_discount_by_categories/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      supplier_article__in,
      product_id__in,
      barcode__in,
      subject_id__in,
    },
  });
  return response.data;
};

export { getCommissionsAndDiscountsByCategories };
